/* eslint-disable */
import Vue from "vue";
import faq from "./faq.vue";
import disclosure from "./disclosure.vue";
import eventHub from "apps/bankrate-events";
import imageCarousel from "./image-carousel.vue";
import { Slide } from 'vue-carousel';
import utils from 'apps/utility/vue-common'
import { Tooltip } from '@bankrate/vue-components'
import '@bankrate/vue-components/dist/br-components.css'

if (document.querySelector(".faq-section faq")) {
    new Vue({
        el: ".faq-section",
        components: {
            faq: faq
        },
        computed: {
            isDesktop() {
                return utils.methods.isDesktop()
            }
        }
    });
}

if (document.querySelector(".disclosure bankrate-disclosure")) {
    new Vue({
        el: ".disclosure",
        components: {
            'bankrate-disclosure': disclosure
        }
    });
}

if (document.querySelector("#image-swiper image-carousel") || document.querySelector("#image-swiper slide")) {
    new Vue({
        el: "#image-swiper",
        components: {
            'image-carousel': imageCarousel,
            'slide': Slide
        }
    });
}

if (document.querySelector(".br-tooltip-comp")) {
    let tooltipNodeList = document.querySelectorAll('.br-tooltip-comp');
    for (let i = 0; i < tooltipNodeList.length; i++) {
        new Vue({
            el: tooltipNodeList[i],
            components: {Tooltip}
        });
    }
}

// Trigger events on HTML click
document.addEventListener("click", function(){
    eventHub.$emit("bankrate-disclosure::close");
});
